module.exports = __webpack_public_path__ + "img/AT.f314b9aa.svg";